// extracted by mini-css-extract-plugin
module.exports = {"icon":"TimerIcon_icon__rgIpW","path":"TimerIcon_path__eachn","warning":"TimerIcon_warning__xA9ra"};